import React from "react";
import cx from "classnames";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import SearchField from "../../../../components/search_field/SearchField";

import styles from './Search.module.scss';

type SearchProps = {
    onSearch: (value: string) => void;
    setValue: (value: string) => void;
    value: string;
};

function Search({onSearch, setValue, value}: SearchProps) {

    const onChange = (value: string) => {
        setValue(value);
    }
    return (
        <div className={cx(styles.article, {
            [styles.articleSearch]: value
        })}>
            <Container>
                <div className={styles.searchContainer}>
                    <Row>
                        <Col className='p-0'>
                            <h1 className={styles.title}>
                                Блог
                            </h1>
                            <SearchField onSearch={onSearch} setValue={onChange} value={value}/>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
}

export default Search;
